import {
  faAmpersand,
  faBinary,
  faBracketsCurly,
  faBracketsSquare,
  faCalendarClock,
  faChartScatter,
  faEmptySet,
  faFunction,
  faGear,
  faGreaterThanEqual,
  faInfo,
  faInputText,
  faObjectIntersect,
  faPenField,
  faPercent,
  faScaleUnbalanced,
  faTheta,
  faValueAbsolute,
} from "@fortawesome/pro-duotone-svg-icons";

export const masterTree = [
  {
    text: "Functions",
    expanded: false,
    isParent: true,
    fontawesomeIcon: faFunction,
    initialPrimaryColor: "#605e5c",
    isSelected: false,
    items: [
      {
        text: "Algebra",
        fontawesomeIcon: faFunction,
        isSelected: false,
      },
      {
        text: "Arithmetic",
        fontawesomeIcon: faValueAbsolute,
        isSelected: false,
      },
      {
        text: "Bitwise",
        fontawesomeIcon: faBinary,
        isSelected: false,
      },
      {
        text: "Combinatorics",
        fontawesomeIcon: faBracketsCurly,
        isSelected: false,
      },
      {
        text: "Complex",
        fontawesomeIcon: faInfo,
        isSelected: false,
      },
      {
        text: "Date",
        fontawesomeIcon: faCalendarClock,
        isSelected: false,
      },
      {
        text: "Geometry",
        fontawesomeIcon: faObjectIntersect,
        isSelected: false,
      },
      {
        text: "Logical",
        fontawesomeIcon: faAmpersand,
        isSelected: false,
      },
      {
        text: "Matrix",
        fontawesomeIcon: faBracketsSquare,
        isSelected: false,
      },
      {
        text: "Probability",
        fontawesomeIcon: faPercent,
        isSelected: false,
      },
      {
        text: "Relational",
        fontawesomeIcon: faGreaterThanEqual,
        isSelected: false,
      },
      {
        text: "Set",
        fontawesomeIcon: faEmptySet,
        isSelected: false,
      },
      {
        text: "Special",
        fontawesomeIcon: faFunction,
        isSelected: false,
      },
      {
        text: "Statistics",
        fontawesomeIcon: faChartScatter,
        isSelected: false,
      },
      {
        text: "String",
        fontawesomeIcon: faInputText,
        isSelected: false,
      },
      {
        text: "Trigonometry",
        fontawesomeIcon: faTheta,
        isSelected: false,
      },
      {
        text: "Unit",
        fontawesomeIcon: faScaleUnbalanced,
        isSelected: false,
      },
      {
        text: "Utilities",
        fontawesomeIcon: faGear,
        isSelected: false,
      },
    ],
  },
  {
    text: "Fields",
    fontawesomeIcon: faPenField,
    isSelected: false,
  },
];

export default masterTree;
